import React from 'react'
import AppHeader from '../../Header'
import PropTypes from 'prop-types'

const ConfigLayout = (props) => {
  return (
    <>
      <AppHeader type='config' showUser={props.showUser} />
      <div style={{ minHeight: '80vh' }}>
        {
          props.children
        }
      </div>
    </>
  )
}

ConfigLayout.propTypes = {
  showUser: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

export default ConfigLayout
